import React from "react";
import "./imagespinner.css";

export default function ImageSpinner() {
  return (
    <div className="App">
      <header className="App-header">
        <img
          src={"../../assets/logo2.png"}
          className="App-logo"
          alt="logo"
        />
      </header>
    </div>
  );
}
